
define('text!modules/files/files_template.html',[],function () { return '<div class="js-files-header"></div>\r\n<ul class="list files-list js-files-list"></ul>\r\n';});

